<template>
  <div v-if="show" class="common-popup-bg">
    <div class="common-popup">
      <h3>权限配置</h3>
      <el-tabs tab-position="left">
        <el-tab-pane v-for="tab of info" :key="tab.code" :label="tab.name">
          <div class="content">
            <template v-for="item of tab.permissionGroups">
              <comp-el-radio-group
                v-if="item.radio"
                ref="radio"
                :key="item.name"
                :info="item"
              />
              <comp-el-checkbox-group
                v-else
                ref="group"
                :key="item.name"
                :info="item"
              />
            </template>
          </div>
        </el-tab-pane>
      </el-tabs>
      <footer>
        <el-button size="small" @click="show = false">取消</el-button>
        <el-button size="small" type="primary" @click="submit">确定</el-button>
      </footer>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import compElCheckboxGroup from "./compElCheckboxGroup";
import compElRadioGroup from "./compElRadioGroup";

export default {
  components: {
    compElCheckboxGroup,
    compElRadioGroup,
  },
  props: {
    info: Array,
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    ...mapActions("authUsers", ["updatePermissions"]),
    submit() {
      let arr = [];
      this.$refs.group.forEach((item) => {
        arr = arr.concat(item.value);
      });
      if (this.$refs.radio) {
        this.$refs.radio.forEach((item) => {
          if (item.value) {
            arr.push(item.value);
          }
        });
      }
      this.$emit("my-submit", {
        value: arr,
        cb: () => {
          this.show = false;
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
:global(.el-tabs) {
  width: 1000px;
  height: 60vh !important;
  :global(.el-tabs__content) {
    height: 100%;
    @extend %scrollbar;
  }
}

:global(.el-tabs--left .el-tabs__header.is-left) {
  height: 100%;
  margin-right: 0;
}

.content {
  padding: 0 20px 20px;
}
</style>
